import { apiHelper } from '@/helpers/apiHelper'
import API from '@axios'

export default {
  async getWidgets() {
    return API.get('/api/report-dashboard/widgets')
  },
  getOneExportFile: id => API.get(`api/core/bulk_data/exports/download/${id}`),
}
